export function isNullOrUndefined(value: any): boolean {
	return value === null || value === undefined;
}

export function isNullOrEmpty(value: string | null | undefined): boolean {
	return value === null || value === undefined || value.trim() === "";
}

export const toCamelCase = (obj: any): any => {
	if (Array.isArray(obj)) {
		return obj.map(toCamelCase);
	} else if (obj !== null && typeof obj === "object") {
		return Object.fromEntries(
			Object.entries(obj).map(([key, value]) => [
				key.replace(/_([a-z])/g, (_, char) => char.toUpperCase()),
				value === null ? undefined : toCamelCase(value),
			])
		);
	}
	return obj;
};

export function camelCaseToSpaced(value: string): string {
	return value.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
}

export const toSnakeCase = (obj: any): any => {
	if (Array.isArray(obj)) {
		return obj.map(toSnakeCase);
	} else if (obj !== null && typeof obj === "object") {
		return Object.fromEntries(
			Object.entries(obj).map(([key, value]) => [
				key.replace(/([A-Z])/g, "_$1").toLowerCase(),
				value === undefined ? null : toSnakeCase(value),
			])
		);
	}
	return obj;
};

export function getInitials(name?: string): string {
	if (!name) return "??";
	return name
		.split(" ")
		.map(n => n[0])
		.join("")
		.toUpperCase()
		.slice(0, 2);
}

/** Convert rich-text HTML (e.g. TipTap step descriptions) to a plain, speakable string. */
export function htmlToPlainText(html: string | undefined): string {
	if (!html) return "";
	if (typeof window === "undefined" || typeof DOMParser === "undefined") {
		return html
			.replace(/<[^>]*>/g, " ")
			.replace(/&nbsp;/g, " ")
			.replace(/\s+/g, " ")
			.trim();
	}
	const doc = new DOMParser().parseFromString(html, "text/html");
	return (doc.body.textContent ?? "").replace(/\s+/g, " ").trim();
}
